import { render, staticRenderFns } from "./app-detail-download-top.vue?vue&type=template&id=13915664&scoped=true&"
import script from "./app-detail-download-top.vue?vue&type=script&lang=js&"
export * from "./app-detail-download-top.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-download-top.vue?vue&type=style&index=0&id=13915664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13915664",
  null
  
)

export default component.exports